/*
  LK-IOS-FIX (2026-10-18, updated 2026-10-19) — touch screens (iPhone, Android, iPad without mouse): a finger press on a
  card shows the same lift / tilt that a mouse hover shows on desktop. Runs only on touch screens and only when Reduce
  Motion is off; desktop keeps its own hover script in sections/lk-bestsellers-bento.liquid.
  LK-IOS-FIX2: the press now starts only when the finger rests for ~0.1 s (like the iPhone's own press effect). Before,
  every scroll that began on a card lifted the bottles and lit the shine for a moment, which looked like flickering on
  the ritual rail and the Best-seller cards. A quick tap still shows the effect briefly. A press ends as soon as the
  finger moves (scrolling) or lifts. Styles: assets/lymko-ios-fixes.css.
  TO REVERT: delete this file, assets/lymko-ios-fixes.css and their two tags in layout/theme.liquid.
*/
(() => {
  "use strict";
  if (window.__lk_iosfix) return;
  window.__lk_iosfix = 1;
  let mq, rm;
  try {
    mq = matchMedia("(hover:none)");
    rm = matchMedia("(prefers-reduced-motion: reduce)");
  } catch (e) {
    return;
  }
  const SEL = ".lkbs .bs-c:not(.open), .lkbs .bs-end, .card";
  const HOLD = 110;
  let cur = null, sx = 0, sy = 0, tmr = 0, pend = 0, on = false;
  const activate = (c) => {
    clearTimeout(pend);
    pend = 0;
    if (cur !== c || on) return;
    on = true;
    c.classList.add("lk-press");
    if (c.classList.contains("bs-c")) {
      const r = c.getBoundingClientRect();
      if (!r.width || !r.height) return;
      const x = Math.max(0, Math.min(1, (sx - r.left) / r.width));
      const y = Math.max(0, Math.min(1, (sy - r.top) / r.height));
      const m = c.classList.contains("hero") ? 3 : 6;
      c.classList.add("tilt");
      c.style.setProperty("--ry", ((x - 0.5) * m * 2).toFixed(2) + "deg");
      c.style.setProperty("--rx", ((0.5 - y) * m * 2).toFixed(2) + "deg");
      c.style.setProperty("--mx", (x * 100).toFixed(1) + "%");
      c.style.setProperty("--my", (y * 100).toFixed(1) + "%");
    }
  };
  const release = () => {
    clearTimeout(tmr);
    clearTimeout(pend);
    pend = 0;
    const c = cur;
    cur = null;
    if (!c) return;
    const was = on;
    on = false;
    if (!was) return;
    c.classList.remove("lk-press");
    if (c.classList.contains("bs-c")) {
      c.classList.remove("tilt");
      c.style.setProperty("--rx", "0deg");
      c.style.setProperty("--ry", "0deg");
    }
  };
  document.addEventListener("touchstart", (e) => {
    if (!mq.matches || rm.matches || e.touches.length !== 1) return release();
    const t = e.target;
    if (!t || !t.closest || t.closest("[data-bsin], .bs-in")) return release();
    const c = t.closest(SEL);
    if (!c) return release();
    if (cur && cur !== c) release();
    clearTimeout(tmr);
    if (cur === c && on) return;
    cur = c;
    const p = e.touches[0];
    sx = p.clientX;
    sy = p.clientY;
    clearTimeout(pend);
    pend = setTimeout(() => activate(c), HOLD);
  }, { passive: true });
  document.addEventListener("touchmove", (e) => {
    if (!cur) return;
    const p = e.touches[0];
    if (!p || Math.abs(p.clientX - sx) + Math.abs(p.clientY - sy) > 10) release();
  }, { passive: true });
  document.addEventListener("touchend", () => {
    if (!cur) return;
    if (!on) activate(cur);
    clearTimeout(tmr);
    tmr = setTimeout(release, 220);
  }, { passive: true });
  document.addEventListener("touchcancel", release, { passive: true });
  addEventListener("pagehide", release);
  document.addEventListener("visibilitychange", () => { if (document.hidden) release(); });
})();

/*
  LK-IOS-FIX (2026-10-18) — product page "What's inside" / "How to use" on phones.
  a) When the shopper is on the 3rd or a later image, these buttons first swipe the gallery back to image 1. iPhone
     swipes back more slowly than the gallery waited (0.56 s), so the panel opened and was closed again straight away.
     Now the button waits until the gallery has really arrived on image 1, then opens as before.
     Only for the swipe gallery on phones; desktop and image 1 behave exactly as before.
  b) The ingredient lines are drawn with their real length instead of pathLength="1" (which older iPhones ignore, so
     the lines showed dotted). Same draw-in animation, same look in Chrome.
  TO REVERT: delete this block.
*/
(() => {
  "use strict";
  if (window.__lk_iosfix2) return;
  window.__lk_iosfix2 = 1;
  const swipeBox = () => {
    const sc = document.getElementById("slides");
    if (!sc) return null;
    const ox = getComputedStyle(sc).overflowX;
    return ox === "auto" || ox === "scroll" ? sc : null;
  };
  const onFirst = (sc) => {
    const t = document.querySelector("#thumbs button");
    return sc.scrollLeft < 2 && (!t || t.classList.contains("on"));
  };
  document.addEventListener("click", (e) => {
    const b = e.target && e.target.closest && e.target.closest('#lkxbar [data-x="inside"], #lkxbar [data-x="play"]');
    if (!b || b.__lkIos || b.__lkPass || b.getAttribute("aria-pressed") === "true") return;
    const sc = swipeBox();
    if (!sc || sc.scrollLeft < 2 || typeof window.__lkGo !== "function") return;
    e.stopImmediatePropagation();
    e.preventDefault();
    if (b.__lkWait) return;
    b.__lkWait = 1;
    window.__lkGo(0);
    const s0 = Date.now();
    let ok = 0;
    const tick = () => {
      ok = onFirst(sc) ? ok + 1 : 0;
      if (ok >= 3 || Date.now() - s0 > 2600) {
        b.__lkWait = 0;
        b.__lkIos = 1;
        b.click();
        b.__lkIos = 0;
        return;
      }
      setTimeout(tick, 50);
    };
    setTimeout(tick, 120);
  }, true);
  const fixLines = (root) => {
    root.querySelectorAll(".lk-cst line[pathLength]").forEach((q) => {
      const L = (Math.hypot(+q.getAttribute("x2") - +q.getAttribute("x1"), +q.getAttribute("y2") - +q.getAttribute("y1")) + 1).toFixed(1);
      q.removeAttribute("pathLength");
      q.style.strokeDasharray = L;
      q.style.strokeDashoffset = L;
    });
  };
  const watch = () => {
    const g = document.getElementById("gmain");
    if (!g || g.__lkLines || !("MutationObserver" in window)) return;
    g.__lkLines = 1;
    new MutationObserver(() => fixLines(g)).observe(g, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch); else watch();
  document.addEventListener("shopify:section:load", () => setTimeout(watch, 80));
})();

/*
  LK-IOS-FIX2 (2026-10-19) — product page picture on phones: pinch to zoom in and out.
  After pinching back out, the picture frame could scroll up and down inside itself, or stop half-way between two
  pictures (two pictures showing joined together). While two fingers are on the picture the frame is now locked
  (class .lk-pinch, see assets/lymko-ios-fixes.css); a finger that stays on after the pinch no longer drags the
  frame; once every finger is lifted, and again whenever the zoom ends, the frame is put back exactly on the picture
  that is selected (no vertical offset). Zoom itself, double-tap, the +/- buttons, swiping between pictures and the
  full-screen viewer work exactly as before. Phones only.
  TO REVERT: delete this block and section j) in assets/lymko-ios-fixes.css.
*/
(() => {
  "use strict";
  if (window.__lk_iosfix3) return;
  window.__lk_iosfix3 = 1;
  let mob;
  try { mob = matchMedia("(max-width:780px)"); } catch (e) { return; }
  const gmOf = (t) => (t && t.closest ? t.closest("#gmain") : null);
  const settle = (gm) => {
    if (!gm || !gm.isConnected) return;
    const sc = gm.querySelector("#slides") || gm.querySelector(".slides");
    if (!sc) return;
    if (sc.scrollTop) sc.scrollTop = 0;
    if (!mob.matches || gm.classList.contains("zoomed") || gm.classList.contains("lk-pinch")) return;
    const w = sc.clientWidth;
    if (!w) return;
    const th = [...document.querySelectorAll("#thumbs button")];
    let i = th.findIndex((b) => b.classList.contains("on"));
    if (i < 0) i = Math.round(sc.scrollLeft / w);
    const x = i * w;
    if (Math.abs(sc.scrollLeft - x) > 1) sc.scrollTo({ left: x, behavior: "auto" });
  };
  const later = (gm) => {
    requestAnimationFrame(() => settle(gm));
    setTimeout(() => settle(gm), 400);
  };
  document.addEventListener("touchstart", (e) => {
    const gm = gmOf(e.target);
    if (!gm) return;
    if (e.touches.length >= 2) gm.classList.add("lk-pinch");
  }, { passive: true, capture: true });
  document.addEventListener("touchmove", (e) => {
    const gm = gmOf(e.target);
    if (gm && gm.classList.contains("lk-pinch") && e.touches.length < 2 && e.cancelable) e.preventDefault();
  }, { passive: false, capture: true });
  const end = (e) => {
    const gm = document.getElementById("gmain");
    if (!gm || !gm.classList.contains("lk-pinch")) return;
    if (e.touches && e.touches.length) return;
    gm.classList.remove("lk-pinch");
    later(gm);
  };
  document.addEventListener("touchend", end, { passive: true, capture: true });
  document.addEventListener("touchcancel", end, { passive: true, capture: true });
  const watch = () => {
    const gm = document.getElementById("gmain");
    if (!gm || gm.__lkPz || !("MutationObserver" in window)) return;
    gm.__lkPz = 1;
    let was = gm.classList.contains("zoomed");
    new MutationObserver(() => {
      const z = gm.classList.contains("zoomed");
      if (was && !z) later(gm);
      was = z;
    }).observe(gm, { attributes: true, attributeFilter: ["class"] });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch); else watch();
  document.addEventListener("shopify:section:load", () => setTimeout(watch, 80));
  addEventListener("pageshow", () => { const gm = document.getElementById("gmain"); if (gm) { gm.classList.remove("lk-pinch"); settle(gm); } });
})();
